import React, {Fragment, useContext} from 'react'
import {AppContext} from '../app/app'
import Config from '../launch/config'
import EntityPreview from '../entity/preview'
import {getFactionTextColor} from './utils'

import './css/atlas-list.css'

const AtlasList = ({isModalOpen}) => {
    const {
        config,
        setModalContentType,
        toggleGameOverOverlay,
        toggleModal,
    } = useContext(AppContext)

    const filtered = Object.keys(config.entities).filter(
        (key) => config.entities[key].discovered
    )

    if (!isModalOpen) {
        return null
    }

    return (
        <Fragment>
            {filtered.map((key, index) => {
                const entity = config.entities[key]
                const {faction, name, orbitingShips, x, y} = entity

                const ships = Object.keys(orbitingShips).filter((key) => {
                    const ship = config.ships[key]
                    return (
                        ship &&
                        ship.faction === Config.userFactionName &&
                        ship.type !== 'satellite'
                    )
                })

                const satellites = Object.keys(orbitingShips).filter((key) => {
                    const ship = config.ships[key]
                    return (
                        ship &&
                        ship.faction === Config.userFactionName &&
                        ship.type === 'satellite'
                    )
                })

                return (
                    <div
                        className="atlas-list__item"
                        key={index}
                        onClick={() => {
                            Config.scene.cameras.main.pan(
                                x,
                                y,
                                300,
                                'Linear',
                                true
                            )
                            setModalContentType(null)
                            toggleModal()
                            toggleGameOverOverlay(true)
                        }}
                    >
                        <EntityPreview
                            entity={entity}
                            isModalOpen={isModalOpen}
                        />
                        <div className="atlas-list__description">
                            <div
                                style={{
                                    color: `#${getFactionTextColor(faction)}`,
                                }}
                            >
                                {name}
                            </div>
                            <div className="atlas-list__ships">
                                {ships.length > 0 ? (
                                    <div className="atlas-list__ships-item">
                                        <img
                                            alt="ship"
                                            className="atlas-list__icon atlas-list__icon--ship"
                                            src={`${process.env.PUBLIC_URL}/img/ship-green.png`}
                                        />

                                        {ships.length}
                                    </div>
                                ) : null}

                                {satellites.length > 0 ? (
                                    <div className="atlas-list__ships-item">
                                        <img
                                            alt="satellite"
                                            className="atlas-list__icon"
                                            src={`${process.env.PUBLIC_URL}/img/satellite-green.png`}
                                        />

                                        {satellites.length}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                )
            })}
        </Fragment>
    )
}

export default AtlasList
